import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { logoutAction } from '../../redux/slices/userSlices';
const baseUrl = process.env.REACT_APP_BASEURL;
const EcomSellerConfirmation = () => {
  const [update,setUpdate]=useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
 //Get user from store
 const state = useSelector((state) => state.sellers);
 const { sellerregisterAuth } = state;
 console.log(sellerregisterAuth,'ll');
 console.log(sellerregisterAuth?.phoneNumber
  ,'selleraction');
 useEffect(() => {
  const fetchCategories = async () => {
    const response = await axios.post(`${baseUrl}/api/reseller/updatesellertype`,
    {
      phoneNumber:sellerregisterAuth?.phoneNumber
    });
    setUpdate(response.data);
    
  };
  fetchCategories();
}, []);

  return (
    <div>
     <h1>Waiting for confirmation</h1> 
     <Link to="/login"  onClick={() => {
            dispatch(logoutAction());
            navigate("/");
          }}>Back to login</Link>
    </div>
  )
}

export default EcomSellerConfirmation
